import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';
import CircularPagingTable from './CircularPagingTable';
import YearCombo from '../common/YearCombo';
import { Helmet } from 'react-helmet';
import { getBaseName } from '../common/Utils';

class CircularListPanel extends Component {

    constructor(props) {
        super(props);

        const { history } = this.props;
        
        if ( typeof(history.location.state) === 'undefined' ) {
            history.replace(history.location.path,{pageNo:0});
        }

        this.state = {
            query: {
                lang: props.match.params.lang,
                category: props.category,
                postDocType: props.postDocType,
                year: new Date().getFullYear(),
                pageNo: history.location.state['pageNo'],
                pageSize: 20,
                sort: {
                    field: 'issueDate',
                    order: 'desc'
                },
                isLoading: true,
                errors: null,
                items: null,
                total: -1
            }
        };
    }

    componentDidMount() {
        //this.props.resetJsMenu();

        setTimeout(() => {this.refreshTable();},1500);

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }

    }

    mergeQuery(updates) {
        let state = this.state;
        let mergedQuery = Object.assign({},state.query,updates);
        state.query = mergedQuery;
        return state;
    }

    async refreshTable() {
        const apiUrl = `${getBaseName()}/api/circular/search`;
        window.scrollTo(0, 0);
        const { query } = this.state;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        }

        let updates = {};
        try {            
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                //console.log(result);

                updates = {
                    items: result.items,
                    total: result.total,
                    errors: null
                };
            } else {

            }
        } catch (error) {
            //console.log(error);
            updates = {
                errors: error
            };
        } finally {
            updates['isLoading'] = false;
            const state = this.mergeQuery(updates);
            this.setState(state);
        }

    }    

    handleYearChange(e) {
        e.preventDefault();
        const updates = { year: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleSortingChange(e, field) {
        e.preventDefault();

        const original = this.state;
        let sort;
        if (field === original.query.sort.field) {
            sort = { field: field };
            if ('asc' === original.query.sort.order) {
                sort['order'] = 'desc';
            } else {
                sort['order'] = 'asc';
            }
        } else {
            sort = {
                field: field,
                order: 'asc'
            };
        }
        const updates = { sort: sort, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handlePageChange(data) {
        const updates = { pageNo: data.selected, isLoading: true };

        const { history } = this.props;
        history.replace(history.location.path,{pageNo:data.selected});

        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    render() {
        const { t } = this.props;
        const { query } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        return (
            <div style={{display:query.isLoading?"none":"block"}}>
                <Helmet>
                    <title>{t(`${query.category}.content.title`)} | {t('common:sfc')}</title>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>
                <div className="headline">
                    {t(`${query.category}.content.title`)}
                </div>
                <div dangerouslySetInnerHTML={{ __html: t(`${query.category}.content.description`)}}></div>
                <br/>
                <div className="date-filter">
                    <YearCombo
                        startYear={2000}
                        year={query.year}
                        handleYearChange={this.handleYearChange.bind(this)}/>
                </div>
                <CircularPagingTable
                    showCategory={"all" === query.category} 
                    query={query} 
                    handleSortingChange={this.handleSortingChange.bind(this)}
                    handlePageChange={this.handlePageChange.bind(this)}/>
            </div>
        );
    }
}

export default withRouter(withTranslation()(CircularListPanel));